<template>
  <div>
    <dialog-card title="Edytuj komentarz" :actions="actions" :handler="handlerClick" ref="card">
      <v-text-field ref="input" v-model="editedValue.message" hide-details="true" label="Komentarz" class="body-1 py-2"
        @keyup.enter.stop="onEnter"></v-text-field>
      <v-textarea label="Szczegóły" v-model="editedValue.comment"  class="body-1 py-2 mt-2" hide-details="true"
          rows="1" auto-grow @keydown.enter.exact.prevent="onEnter"
          @keydown.enter.shift.exact.prevent="editedValue.comment += '\n'">
        </v-textarea>
    </dialog-card>
  </div>
</template>

<script>

export default {
  name: "EditCommentDialog",
  props: {
    model: {
      default: () => (
        {
          message: "",
          comment: "",
        }),
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editedValue: {},
    }
  },
  computed: {
    actions() {
      const baseActions = {
        false: 'Anuluj',
        true: {
          color: 'success',
          text: 'OK',
        },
      }

      if (this.canDelete) {
        // Add delete button, then spacer, then remaining buttons
        return {
          delete: {
            color: 'error',
            text: 'Usuń',
          },
          spacer: 'spacer', // Creates v-spacer that fills the space
          false: 'Anuluj',
          true: {
            color: 'success',
            text: 'OK',
          },
        }
      }

      return baseActions
    },

    isEmpty() {
      return (!this.editedValue.message || this.editedValue.message.trim() === '') &&
             (!this.editedValue.comment || this.editedValue.comment.trim() === '')
    }
  },
  beforeMount() {
    this.editedValue = {
      message: this.model.message,
      comment: this.model.comment
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.input.focus()
    }, 100)
  },
  methods: {
    submit(value) {
      this.$emit("submit", value)
    },
    onEnter() {
      this.$refs.card.$refs.actions.trigger(true)
    },
    handlerClick(res, action) {
      // Handle cancellation
      if (!action.key) {
        this.$emit('submit', action.key)
        return
      }

      // Handle deletion
      if (action.key === 'delete') {
        this.$emit('submit', 'delete')
        return
      }

      // Validation for save
      const valid = this.rules ? this.$refs.input.validate() : true
      if (!valid) {
        this.$refs.input.focus()
        return false
      }

      // If all fields are empty, treat as deletion
      if (this.isEmpty && this.canDelete) {
        this.$emit('submit', 'delete')
        return
      }

      // Normal save
      if (action.key) {
        this.model.message = this.editedValue.message
        this.model.comment = this.editedValue.comment
      }
      this.$emit('submit', action.key ? this.model : action.key)
    }
  }
}
</script>
